import React, { useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const fmt = (s) => {
  const t = Math.max(0, Math.floor(s || 0));
  const h = Math.floor(t / 3600); const m = Math.floor((t % 3600) / 60); const sec = String(t % 60).padStart(2, '0');
  return h ? `${h}:${String(m).padStart(2, '0')}:${sec}` : `${m}:${sec}`;
};
const parse = (v) => v.split(':').reduce((acc, x) => acc * 60 + (Number(x) || 0), 0);

const Mark = ({ label, value, onText, onUseCurrent, onGo, testId }) => (
  <div style={{ display: 'grid', gap: 4 }}>
    <span style={{ fontSize: '0.75rem', opacity: 0.8 }}>{label}</span>
    <div style={{ display: 'flex', gap: 6 }}>
      <input value={value} onChange={(e) => onText(e.target.value)} data-testid={`${testId}-input`} aria-label={label}
        style={{ width: 90, padding: '0.35rem 0.5rem', borderRadius: 6, border: 'none', color: '#0B0F14', fontWeight: 600, textAlign: 'center' }} />
      <button onClick={onUseCurrent} data-testid={`${testId}-current`} style={btn}>Usar posição atual</button>
      <button onClick={onGo} data-testid={`${testId}-go`} style={btn}>Ir</button>
    </div>
  </div>
);

// Editor controls rendered under the full-length player: subscriber stretch (start/end) and catalog visibility
export const AudioTrimEditor = ({ book, token, initial, abs, seekAbs, duration, onSaved }) => {
  const [start, setStart] = useState(fmt(initial.trim_start || 0));
  const [end, setEnd] = useState(fmt(initial.trim_end || duration));
  const [enabled, setEnabled] = useState(initial.enabled !== false);
  const [msg, setMsg] = useState(null);
  const save = async () => {
    setMsg(null);
    try {
      const { data } = await axios.put(`${API}/digital/books/${book.id}/audiobook/settings`, { trim_start: parse(start), trim_end: parse(end), enabled },
        { headers: { Authorization: `Bearer ${token}` } });
      setMsg({ ok: true, text: data.message }); onSaved?.(data);
    } catch (e) { setMsg({ ok: false, text: typeof e.response?.data?.detail === 'string' ? e.response.data.detail : 'Erro ao salvar.' }); }
  };
  return (
    <div data-testid="audio-trim-editor" style={{ marginTop: '1.25rem', paddingTop: '1rem', borderTop: '1px solid rgba(255,255,255,0.15)', textAlign: 'left', display: 'grid', gap: '0.75rem' }}>
      <p style={{ fontSize: '0.85rem', fontWeight: 600 }}>Trecho que o assinante ouve <span style={{ fontWeight: 400, opacity: 0.8 }}>(posição atual: {fmt(abs)})</span></p>
      <Mark label="Início" value={start} onText={setStart} onUseCurrent={() => setStart(fmt(abs))} onGo={() => seekAbs(parse(start))} testId="trim-start" />
      <Mark label="Fim" value={end} onText={setEnd} onUseCurrent={() => setEnd(fmt(abs))} onGo={() => seekAbs(parse(end) - 5)} testId="trim-end" />
      <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: '0.88rem', cursor: 'pointer' }}>
        <input type="checkbox" checked={enabled} onChange={(e) => setEnabled(e.target.checked)} data-testid="audio-enabled-toggle" />
        Exibir o audiolivro no catálogo
      </label>
      <button onClick={save} data-testid="audio-settings-save" style={{ ...btn, background: 'white', color: '#0B0F14', fontWeight: 700, padding: '0.6rem' }}>Salvar trecho e exibição</button>
      {msg && <p data-testid="audio-settings-msg" style={{ fontSize: '0.82rem', color: msg.ok ? '#B7F5C4' : '#FFB4B4' }}>{msg.text}</p>}
    </div>
  );
};

const btn = { border: 'none', borderRadius: 6, padding: '0.35rem 0.6rem', fontSize: '0.75rem', fontWeight: 600, cursor: 'pointer', background: 'rgba(255,255,255,0.15)', color: 'white' };
